import axios from 'axios';
import { callable } from 'modules/firebase';
import { CallableResult } from 'modules/stripe';

export async function uploadFileToCloudflare(
  basePath: FileBasePath,
  file: File,
) {
  try {
    const callableFn = callable<
      FileUploadRequest,
      CallableResult<FileUploadResponse>
    >('uploadFile');

    const response = await callableFn({
      basePath,
      file: {
        name: file.name,
        type: file.type,
        size: file.size,
      },
    });

    if (!response.data.success || !response.data.payload.signedUrl) {
      throw new Error('Failed to upload file');
    }

    await axios.put(response.data.payload.signedUrl, file);

    return {
      path: response.data.payload.path,
      url: response.data.payload.url,
    };
  } catch (error) {
    throw new Error('Error uploading file');
  }
}
